// The miner this browser follows on the dashboard. A per-viewer convenience, so it lives
// in localStorage: nobody else needs to see it, and losing it costs one click. Every
// access is guarded - private windows and blocked storage throw rather than return null.

const KEY = "soma-my-hotkey";
// `storage` only fires in *other* tabs; this one hears about its own writes through this.
const EVENT = "soma-my-hotkey";

export function readMyHotkey(): string | null {
  try {
    const value = window.localStorage.getItem(KEY);
    return value && value.trim() ? value : null;
  } catch {
    return null;
  }
}

export function writeMyHotkey(hotkey: string | null): void {
  try {
    if (hotkey) window.localStorage.setItem(KEY, hotkey);
    else window.localStorage.removeItem(KEY);
  } catch {
    // Storage refused: the mark simply does not stick. Nothing else depends on it.
  }
  window.dispatchEvent(new Event(EVENT));
}

export function subscribeMyHotkey(onChange: () => void): () => void {
  const onStorage = (e: StorageEvent) => {
    if (e.key === KEY) onChange();
  };
  window.addEventListener("storage", onStorage);
  window.addEventListener(EVENT, onChange);
  return () => {
    window.removeEventListener("storage", onStorage);
    window.removeEventListener(EVENT, onChange);
  };
}
